module.exports = __webpack_public_path__ + "img/lt.70975be0.svg";